import { useEffect, useMemo } from "react";
import { ThemeProvider as MuiThemeProvider, createTheme } from "@mui/material/styles";
import { PaletteMode } from "@mui/material";
import { initTheme, useThemeStore } from "./store/themeStore";

function buildTheme(mode: PaletteMode) {
  return createTheme({
    palette: {
      mode,
      primary: {
        main: "#0f6fff",
        dark: "#0b4fcc"
      },
      background: {
        default: mode === "light" ? "#f8fafc" : "#0f172a",
        paper: mode === "light" ? "#ffffff" : "#1e293b"
      }
    },
    shape: {
      borderRadius: 14
    }
  });
}

export const ThemeProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { mode } = useThemeStore();

  useEffect(() => {
    initTheme();
  }, []);

  const muiMode: PaletteMode = useMemo(() => {
    if (mode === "system") {
      return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    }
    return mode;
  }, [mode]);

  const theme = useMemo(() => buildTheme(muiMode), [muiMode]);

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};
